export const QA_NAME_DELETE_RECIPIENT_BUTTON = 'delete'
